<template>
  <div class="d-flex">
<!--    <div :key="property.uuid" class="draggable-item group" :id="'item_' + property.uuid" :data-parent="property.itemUuid" v-if="!isExpanded" @click="toggleExpand([property.uuid])">-->
<!--      <div class="before">-->
<!--        <div>-->
<!--          <div class="d-flex justify-content-center align-items-center">-->
<!--            <i :class="property.subItemType().icon+' fs-3x'" v-if="property.subItemType()?.icon"></i>-->
<!--            <i class="fad fa-folder fs-3x" v-else></i>-->
<!--          </div>-->
<!--          <div class="fw-bolder mt-2 fs-8 px-2 text-uppercase text-center overflow-auto  d-flex align-items-center justify-content-center cursor-pointer" style="max-lines: 2;line-clamp: 2;">-->
<!--            N°1-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="white-box bg-white d-flex justify-content-center align-items-center p-2 border-dashed rounded cursor-pointer  bg-hover-light-primary">-->
<!--        <div class="text-center">-->
<!--          &lt;!&ndash;          <i class="fas fa-layer-plus position-absolute fs-2 text-info" style="top:-10px;right:-10px" title="Groupe d'objets"></i>&ndash;&gt;-->
<!--          <i :class="property.subItemType().icon+' fs-3x'" v-if="property.subItemType()?.icon"></i>-->
<!--          <i class="fad fa-folder fs-3x" v-else></i>-->
<!--          <div class="fw-bolder mt-2 fs-8 px-2 text-uppercase text-center overflow-auto  d-flex align-items-center justify-content-center cursor-pointer" style="max-lines: 2;line-clamp: 2;">-->
<!--            {{ property.model.name }}-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="after">-->
<!--        <div>-->
<!--          <div class="d-flex justify-content-center align-items-center">-->
<!--            <i :class="property.subItemType().icon+' fs-3x'" v-if="property.subItemType()?.icon"></i>-->
<!--            <i class="fad fa-folder fs-3x" v-else></i>-->
<!--          </div>-->
<!--          <div class="fw-bolder mt-2 fs-8 px-2 text-uppercase text-center overflow-auto d-flex align-items-center justify-content-center cursor-pointer" style="max-lines: 2;line-clamp: 2;">-->
<!--            N°...-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <div class="d-flex" style="align-items: flex-start!important">
      <template v-for="(child,index) in property.children">
        <AvenantItemTree :level="index+1" :key="'item_tree'+child" :parentItemUuid="property.itemUuid" :uuid="child" :maxDepth="2" @link="linkChildren" @expand="toggleExpand"/>
      </template>
      <div v-if="canUserAdd" :set="uuid = helper.generateId()" class="draggable-item item-manager bg-hover-light-primary border border-dashed rounded cursor-pointer ms-4 p-2"
           :id="'item_' + uuid" :data-parent="property.itemUuid"
           @click="createItem()">
        <div>
          <div class="d-flex justify-content-center align-items-center">
            <i class="fad fa-plus fs-2x"></i>
          </div>
          <div class="fw-bolder text-muted mt-2 fs-8 px-2 text-uppercase text-center overflow-auto d-flex align-items-center justify-content-center cursor-pointer"
               style="max-lines: 2;line-clamp: 2;">
            Ajouter
            <br>
            {{ property.subItemType().name }}
          </div>
        </div>
      </div>
      <div v-else-if="atMax" class="d-flex align-items-center text-muted fst-italic fs-8 ms-4 p-2" :title="'Maximum ' + maxChildren + ' atteint'">
        <i class="fad fa-circle-info me-2"></i>Maximum {{ maxChildren }} atteint
      </div>
    </div>
  </div>
</template>


<script lang="ts">
import {Vue, Component, Prop} from 'vue-property-decorator';
import {createItemFromType, getItemModel} from "@/services/ItemFunction";
import store from "@/store";
import {helper} from "@/services/Helper";

@Component({
  name: 'AvenantObjectGroupManager',
  components: {},
})
export default class AvenantObjectGroupManager extends Vue {

  @Prop() property!: any
  @Prop({default: 1}) level!: number
  expand = false
  filter = {
    page: 1,
  }

  get isExpanded() {
    return this.$store.state.contractStore.itemsExpanded.includes(this.property.uuid)
  }

  get children() {
    return this.$store.getters["contractStore/getEntitiesByUuid"]('items', this.property.children)
  }

  get avenantType() {
    return this.$store.state.contractStore.avenantType
  }

  // Cardinalite max definie sur la propriete (ex. 5 enfants).
  // Convention : null/0 = illimite (la base stocke 0 quand non configure).
  get maxChildren(): number | null {
    const n = Number(this.property?.model?.max)
    return (isNaN(n) || n <= 0) ? null : n
  }

  get atMax(): boolean {
    return this.maxChildren !== null && this.property.children.length >= this.maxChildren
  }

  // L'ajout d'un enfant doit respecter : la config du type d'avenant
  // (allowAdd / allowedAddition) ET la cardinalite max de la propriete.
  get canUserAdd(): boolean {
    const at = this.avenantType
    if (at) {
      if (at.allowAdd === false) return false
      const code = this.property.subItemType()?.code
      if (at.allowedAddition?.length > 0 && code && !at.allowedAddition.includes(code)) return false
    }
    return !this.atMax
  }

  mounted() {
    this.$emit('link')
  }

  linkChildren() {
    this.$emit('link')
  }

  toggleExpand(evt: any) {
    this.expand = !this.expand

    // console.log(evt)
    if (Array.isArray(evt) && evt.length === 1 && evt[0] !== 'null_item') {
      // console.log(this.property)
      if (this.property.model.min !== null && !isNaN(this.property.model.min)) {
        // On remplit jusqu'au min, sans jamais depasser le max.
        let target = this.property.model.min
        if (this.maxChildren !== null) {
          target = Math.min(target, this.maxChildren)
        }
        const missing = target - this.property.children.length
        if (missing > 0) {
          for (let i = 0; i < missing; i++) {
            this.createItem()
          }
        }
      }
    }
    if (!Array.isArray(evt)) {
      evt = [this.property.uuid]
    } else if (evt.length > 0) {
      evt.push(this.property.uuid)
    }
    this.$emit('expand', evt)
    this.$emit('link')
  }

  createItem() {
    // Garde-fou : ne jamais depasser la cardinalite max de la propriete.
    if (this.atMax) {
      return
    }
    const item = createItemFromType(this.property.subItemType())
    item.name = getItemModel(item)?.name + ' N°' + (this.property.children.length + 1)
    item.parentItem = this.property.itemUuid || null
    item.parentPropertyCode = this.property.code || this.property.model?.code
    this.property.children.push(item.uuid)
    store.commit('contractStore/addEntity', {type: 'items', item: item});
    this.$emit('link')
  }
}
</script>


<style scoped>

.draggable-item {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  min-width: 100px;
  aspect-ratio: 1/1;
  z-index: 1;
  background: white;
  perspective: 800px;
}

.draggable-item:hover .white-box {
  border-color: var(--bs-blue)
}

.draggable-item.group .white-box {
  width: 100%;
  height: 100%;
  position: relative;
  flex: 1;
  transition: all .5s ease;
}

.draggable-item.group .before {
  position: absolute;
  content: '';
  width: 80%;
  height: 80%;
  border: 1px gray dashed;
  background: whitesmoke;
  display: flex;
  align-items: center;
  justify-content: center;
  left: -35%;
  top: 10%;
  border-radius: 5px;
  z-index: -1;
  transform: rotateY(35deg);
  transition: all .5s ease;
}

.draggable-item.group .after {
  position: absolute;
  content: '';
  width: 80%;
  height: 80%;
  border: 1px gray dashed;
  display: flex;
  align-items: center;
  justify-content: center;
  background: whitesmoke;
  right: -35%;
  top: 10%;
  border-radius: 5px;
  z-index: -1;
  transform: rotateY(-35deg);
  transition: all .5s ease .1s;
}

.draggable-item.group:hover .before {
  left: -70%;
  transform: rotateY(35deg);
  background: #ECF8FF;
  border: 1px dashed var(--bs-blue);
}

.draggable-item.group:hover .after {
  right: -70%;
  transform: rotateY(-35deg);
  background: #ECF8FF;
  border: 1px dashed var(--bs-blue);

}

.item-tree-container > .menu {
  opacity: 0;
  display: flex;
  transition: all .5s ease;
  transform: translateX(10px);
}

.item-tree-container:hover > .menu {
  opacity: 1;
  transform: translateX(0);
}
</style>
